import CONFIGS from "../configs";
import paymentSchema from "../utils/paymentObjectUtil";

export const post = async (data, type) => {
    try {
        
        let transactionData = paymentSchema(data, type);
                    
        let baseURL = `http://${CONFIGS.API.HOST}:${CONFIGS.API.PORT}`;
        
        
        if(['sandbox','production'].includes(CONFIGS.MODE)){
            baseURL = `https://${CONFIGS.API.URL}`
        }
        
        baseURL +=`/${CONFIGS.API.SERVICE}/Json/${CONFIGS.API.TRANSACTION_SERVICE}`;
    
        const response = await fetch(baseURL, {
            method: 'POST',
            body: JSON.stringify(transactionData),
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const result = await response.json();
        return result;

    } catch (error) {
        throw error;
    }
}
